import ExtensionIcon from '@mui/icons-material/Extension';
import CardsGridSubmenu from '../../../common/components/cardsGrid/cardsGridSubmenu';
import BasicLayout from '../../../common/layouts/basicLayout';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { CardsGridItem } from '../../../common/components/cardsGrid/cardsGrid';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ArchiveIcon from '@mui/icons-material/Archive';

const cover: CardsGridItem = {
  title: 'TS / Tech',
  icon: ReceiptIcon,
  path: '/integracao',
};

const gridItems: CardsGridItem[] = [
  {
    title: 'Saída EDI',
    icon: ImportExportIcon,
    path: '/integracao/ts-tech/edi',
    requiredRoles: ['thermo-fisher-visualizar'],
  },
  {
    title: 'Romaneio DI',
    icon: ImportExportIcon,
    path: '/integracao/ts-tech/romaneio',
    requiredRoles: ['thermo-fisher-visualizar'],
  },
  {
    title: 'Draft Danfe',
    icon: ImportExportIcon,
    path: '/integracao/ts-tech/danfe',
    requiredRoles: ['thermo-fisher-visualizar'],
  },
  {
    title: 'Gerar Relatórios',
    icon: ArchiveIcon,
    path: '/integracao/ts-tech/relatorios',
    requiredRoles: ['thermo-fisher-visualizar'],
  },
];

const TsTechPage = () => {
  return (
    <BasicLayout title={'Ts-Tech'} icon={<ExtensionIcon color={'secondary'} />}>
      <CardsGridSubmenu cover={cover} items={gridItems}></CardsGridSubmenu>
    </BasicLayout>
  );
};

export default TsTechPage;
